import React, { useState } from 'react';
import styled from 'styled-components';
import TabControl from './TabControl';
import PlayField from './PlayField';

const TabsContainer = styled.div`
    border: 1px #d9b18f solid;
    padding: 16px 0 32px 0;
    border-radius: 16px;
    max-width: 720px;
`;

export default function TabPlayer({ song }) {
    const [songPosition, setSongPosition] = useState(null);

    return <TabsContainer>
        <TabControl song={song} onChangeSongPosition={setSongPosition}/>
        <PlayField song={song} track={song.tracks[0]} songPosition={songPosition}/>
    </TabsContainer>
}
